export function getSupportSought({
  stretch,
  attachment,
  structureType,
}: {
  stretch?: string;
  attachment?: string;
  structureType?: string;
}) {
  if (!stretch) {
    return "-";
  }
  const stretchNumber = Number(stretch) / 1000000;
  if (!attachment || attachment === "0") {
    switch (structureType) {
      case "non-proportional":
        return `Primary ${stretchNumber}`;
      case "proportional":
        return `QS ${stretchNumber}`;
      default:
        return "-";
    }
  }
  const attachmentNumber = Number(attachment) / 1000000;
  return `${attachmentNumber} x ${stretchNumber}`;
}
